import { getField, updateField } from 'vuex-map-fields';
import { STATUS } from "../../store/modules/me";
import { client} from "@/api/client";
import { STATE_TRANSLATOR } from '@/modules/facturae/domain/Invoiceable';


const SET_CONTRACT_DATE = 'SET_CONTRACT_DATE';
const SET_END_DATE = 'SET_END_DATE';
const SET_SHOW_CONTRACT_MODAL = 'SET_SHOW_CONTRACT_MODAL';
const SET_IS_VISIBLE_EXTRA_USER_CONTRACT_POPUP = 'SET_IS_VISIBLE_EXTRA_USER_CONTRACT_POPUP';
const SET_IS_VISIBLE_PAY_CHARGE_POPUP = 'SET_IS_VISIBLE_PAY_CHARGE_POPUP';
const SET_IS_VISIBLE_REINSTALLATION_POPUP = 'SET_IS_VISIBLE_REINSTALLATION_POPUP';
const SET_REINSTALLATION_POPUP_USER_ID = 'SET_REINSTALLATION_POPUP_USER_ID';
const NOTIFY_REINSTALLATION_CREATED = 'NOTIFY_REINSTALLATION_CREATED';
const NOTIFY_CONTRACTS_UPDATED = 'NOTIFY_CONTRACTS_UPDATED';
const NOTIFY_PAY_CHARGE_COMPLETED = 'NOTIFY_PAY_CHARGE_COMPLETED';
const SET_SELECTED_CONTRACT_FOR_EXTRA_USER_CONTRACT_POPUP = 'SET_SELECTED_CONTRACT_FOR_EXTRA_USER_CONTRACT_POPUP';
const SET_SELECTED_CHARGE_FOR_PAY_CHARGE_POPUP = 'SET_SELECTED_CHARGE_FOR_PAY_CHARGE_POPUP';
const SET_SERVICE_CONTRACT = 'SET_SERVICE_CONTRACT';
const SET_CONTRACT_ACCEPTED = 'SET_CONTRACT_ACCEPTED';
const SET_POLICY_ACCEPTED = 'SET_POLICY_ACCEPTED';
const SET_CONTRACT_TYPE = 'SET_CONTRACT_TYPE';
const SET_CONTRACT_TYPES = 'SET_CONTRACT_TYPES';
const SET_PRICE = 'SET_PRICE';
const SET_NUM_DOCUMENTS = 'SET_NUM_DOCUMENTS';
const SET_WIDTH = 'SET_WIDTH';
const SET_PERSISTENT = 'SET_PERSISTENT';
const SET_CONTRACT = 'SET_CONTRACT';
const SET_ERROR_PROMOTIONAL_CODE = 'SET_ERROR_PROMOTIONAL_CODE';
const SET_CONTRACT_MODAL_MSG = 'SET_CONTRACT_MODAL_MSG';
const SET_CONTRACT_MODAL_DISTRIBUTOR = 'SET_CONTRACT_MODAL_DISTRIBUTOR';
const SET_IS_FACTURAE_PURCHASE_FOR_CLIENT = 'SET_IS_FACTURAE_PURCHASE_FOR_CLIENT';
const SET_CONTRACT_MODAL_WORKING_HOURS_CLIENT = 'SET_CONTRACT_MODAL_WORKING_HOURS_CLIENT';
const SET_SHOW_ONLY_FACTURAE = 'SET_SHOW_ONLY_FACTURAE';
const SET_IS_TAX_DATA_FILLED = 'SET_IS_TAX_DATA_FILLED';
const SET_CAN_SHOW_DOCUMENT_SERVICES_AND_BANKS = 'SET_CAN_SHOW_DOCUMENT_SERVICES_AND_BANKS';
const SET_CAN_SHOW_MIXED = 'SET_CAN_SHOW_MIXED';
const SET_PERSONALIZED_SERVICES = 'SET_PERSONALIZED_SERVICES';
const SET_STAFF_CONTRACT = 'SET_STAFF_CONTRACT';


const state = () => ({
    end_date: false,
    show_contract_modal: false,
    is_visible_extra_user_contract_popup: false,
    is_visible_pay_charge_popup: false,
    is_visible_reinstallation_popup: false,
    reinstallation_popup_user_id: null,
    reinstallation_created_counter: 0,
    contracts_updated_counter: 0,
    pay_charge_completed_counter: 0,
    contract_modal_msg: '',
    contract_modal_distributor: false,
    is_facturae_purchase_for_client: false,
    contract_modal_working_hours_client: false,
    show_only_facturae: false,
    is_tax_data_filled: false,
    can_show_document_services_and_banks: false,
    can_show_mixed: false,
    personalized_services: false,
    // Modo staff del ContractPopup: 'change' (cambiar plan) | 'create' (alta sin pago).
    staff_contract_mode: '',
    staff_contract: null,
    persistent: false,
    contract_date: false,
    contract_types: [],
    num_documents: 0,
    price: 0,
    width: '37%',
    contract: undefined,
    form: {
        service_contract: false,
        contract_accepted: false,
        policy_accepted: false,
        contract_type: undefined,
        promotional_code: '',
        status: STATUS.ACTIVE,
        valid: false,
        error_promotional_code: false,
        error_promotional_code_list: ''

    },
    message_error: {
        promotional_code: 'El código promocional no es válido.'
    }
});


const mutations = {
    [SET_CONTRACT_DATE]: (state, end_date) => {
        state.contract_date = end_date;
    },
    [SET_END_DATE]: (state, end_date) => {
        state.end_date = end_date;
    },
    [SET_SHOW_CONTRACT_MODAL]: (state, show) => {
        state.show_contract_modal = show;
    },
    [SET_IS_VISIBLE_EXTRA_USER_CONTRACT_POPUP]: (state, show) => {
        state.is_visible_extra_user_contract_popup = show;
    },
    [SET_IS_VISIBLE_PAY_CHARGE_POPUP]: (state, show) => {
        state.is_visible_pay_charge_popup = show;
    },
    [SET_IS_VISIBLE_REINSTALLATION_POPUP]: (state, show) => {
        state.is_visible_reinstallation_popup = show;
    },
    [SET_REINSTALLATION_POPUP_USER_ID]: (state, user_id) => {
        state.reinstallation_popup_user_id = user_id;
    },
    [NOTIFY_REINSTALLATION_CREATED]: (state) => {
        state.reinstallation_created_counter += 1;
    },
    [NOTIFY_CONTRACTS_UPDATED]: (state) => {
        state.contracts_updated_counter += 1;
    },
    [NOTIFY_PAY_CHARGE_COMPLETED]: (state) => {
        state.pay_charge_completed_counter += 1;
    },
    [SET_SELECTED_CONTRACT_FOR_EXTRA_USER_CONTRACT_POPUP]: (state, contract) => {
        state.selected_contract_for_extra_user_contract_popup = contract;
    },
    [SET_SELECTED_CHARGE_FOR_PAY_CHARGE_POPUP]: (state, contract) => {
        state.selected_charge_for_pay_charge_popup = contract;
    },
    [SET_SERVICE_CONTRACT]: (state, service_contract) => {
        state.form.service_contract = service_contract;
    },
    [SET_CONTRACT_ACCEPTED]: (state, contract_accepted) => {
        state.form.contract_accepted = contract_accepted;
    },
    [SET_POLICY_ACCEPTED]: (state, policy_accepted) => {
        state.form.policy_accepted = policy_accepted;
    },
    [SET_CONTRACT_TYPE]: (state, contract_type) => {
        state.form.contract_type = contract_type;
    },
    [SET_CONTRACT_TYPES]: (state, contract_types) => {
        state.contract_types = contract_types;
    },
    [SET_NUM_DOCUMENTS]: (state, num_documents) => {
        state.num_documents = num_documents;
    },
    [SET_PRICE]: (state, price) => {
        state.price = price;
    },
    [SET_PERSISTENT]: (state, persistent) => {
        state.persistent = persistent;
    }, 
    [SET_WIDTH]: (state, width) => {
        state.width = width;
    },
    [SET_CONTRACT]: (state, contract) => {
        state.contract = contract;
    },
    [SET_ERROR_PROMOTIONAL_CODE]: (state, error_promotional_code) => {
        state.form.error_promotional_code = error_promotional_code;
        state.form.error_promotional_code_list = (error_promotional_code) ? error_promotional_code : '';
    },
    [SET_CONTRACT_MODAL_MSG]: (state, msg) => {
        state.contract_modal_msg = msg;
    },
    [SET_CONTRACT_MODAL_DISTRIBUTOR]: (state, distributor) => {
        state.contract_modal_distributor = distributor;
    },
    [SET_IS_FACTURAE_PURCHASE_FOR_CLIENT]: (state, facturae_client) => {
        state.is_facturae_purchase_for_client = facturae_client;
    },
    [SET_CONTRACT_MODAL_WORKING_HOURS_CLIENT]: (state, working_hours_client) => {
        state.contract_modal_working_hours_client = working_hours_client;
    },
    [SET_SHOW_ONLY_FACTURAE]: (state, show_only_facturae) => {
        state.show_only_facturae = show_only_facturae
    },
    [SET_IS_TAX_DATA_FILLED]: (state, is_tax_data_filled) => {
        state.is_tax_data_filled = is_tax_data_filled
    },
    [SET_CAN_SHOW_DOCUMENT_SERVICES_AND_BANKS]: (state, can_show_document_services_and_banks) => {
        state.can_show_document_services_and_banks = can_show_document_services_and_banks
    },
    [SET_CAN_SHOW_MIXED]: (state, can_show_mixed) => {
        state.can_show_mixed = can_show_mixed
    },
    [SET_PERSONALIZED_SERVICES]: (state, personalized_services) => {
        state.personalized_services = personalized_services
    },
    [SET_STAFF_CONTRACT]: (state, { mode, contract }) => {
        state.staff_contract_mode = mode
        state.staff_contract = contract
    },
    updateField,
};


const getters = {
    end_date: state => state.end_date,
    contract: state => state.contract,
    show_contract_modal: state => state.show_contract_modal,
    is_visible_extra_user_contract_popup: state => state.is_visible_extra_user_contract_popup,
    is_visible_pay_charge_popup: state => state.is_visible_pay_charge_popup,
    is_visible_reinstallation_popup: state => state.is_visible_reinstallation_popup,
    reinstallation_popup_user_id: state => state.reinstallation_popup_user_id,
    selected_contract_for_extra_user_contract_popup: state => state.selected_contract_for_extra_user_contract_popup,
    selected_charge_for_pay_charge_popup: state => state.selected_charge_for_pay_charge_popup,
    contract_modal_msg: state => state.contract_modal_msg,
    contract_modal_distributor: state => state.contract_modal_distributor,
    is_facturae_purchase_for_client: state => state.is_facturae_purchase_for_client,
    contract_modal_working_hours_client: state => state.contract_modal_working_hours_client,
    show_only_facturae: state => state.show_only_facturae,
    is_tax_data_filled: state => state.is_tax_data_filled,
    can_show_document_services_and_banks: state => state.can_show_document_services_and_banks,
    can_show_mixed: state => state.can_show_mixed,
    personalized_services: state => state.personalized_services,
    staff_contract_mode: state => state.staff_contract_mode,
    staff_contract: state => state.staff_contract,
    promotional_code: state => state.form.promotional_code,
    service_contract: state => state.form.service_contract,
    contract_accepted: state => state.form.contract_accepted,
    policy_accepted: state => state.form.policy_accepted,
    contract_type: state => state.form.contract_type,
    num_documents: state => state.num_documents,
    price: state => state.price,
    contract_date: state => state.contract_date,
    persistent: state => state.persistent,
    width: state => state.width,
    form: state => state.form,
    getField
}

const calculateEndDate = ({ commit }) => {
    let end_date = '';
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const yyyy = today.getFullYear();
    end_date = dd + '/' + mm + '/' + (yyyy + 1);
    commit(SET_END_DATE, end_date);
}

const calculateContractDate = ({ commit }) => {
    let months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    let now = new Date();
    let day = now.getDate();
    let year = now.getFullYear();
    let month = now.getMonth()
    let contract_date = day + ' de ' + months[month] + ' de ' + year;
    commit(SET_CONTRACT_DATE, contract_date)
}

const selectPlan = ({ commit, dispatch, state}, contract_type) => {
    commit(SET_CONTRACT_TYPE, contract_type);
    dispatch('updateContractInfo');
    dispatch('legal_contract/updateParams', {docs_num: state.num_documents, price: state.price}, { root: true })
}

const setServiceContract = ({ commit }, service_contract) => {
    commit(SET_SERVICE_CONTRACT, service_contract)
}

const fillForm = ({ commit, dispatch }, userData) => {
    commit(SET_CONTRACT_ACCEPTED, userData.contract_accepted);
    commit(SET_POLICY_ACCEPTED, userData.policy_accepted);
    commit(SET_CONTRACT_TYPE, userData.contract_type);
    for (let i in userData.contracts) {
        if (userData.contracts[i]['is_actualizable']) {
            let contract = userData.contracts[i];
            commit(SET_CONTRACT, contract);
        }
    }
    dispatch('updateContractInfo');

}

const setContractTypes = ({ commit, dispatch }, contract_types) => {
    commit(SET_CONTRACT_TYPES, contract_types);
    dispatch('updateContractInfo');
}

const updateContractInfo = ({ commit, state }) => {
    if (state.contract_types.length > 0 && state.form.contract_type) {
        for (var i = 0; i < state.contract_types.length; i++) {
            console.log("uuuuu", state.contract_types[i].id, state.form.contract_type)
            if (state.contract_types[i].id == state.form.contract_type) {
                commit(SET_PRICE, state.contract_types[i].price);
                commit(SET_NUM_DOCUMENTS, state.contract_types[i].docs_num);
            }
        }
    }
}

// const updateContractInfo = ({ commit, state }) => {
//     if (state.contract_types.length > 0 && state.form.contract_type) {
//         for (var i = 0; i < state.contract_types.length; i++) {
//             console.log("uuuuu", state.contract_types[i].id, state.form.contract_type)
//             if (state.contract_types[i].id == state.form.contract_type) {
//                 commit(SET_PRICE, state.contract_types[i].price);
//                 commit(SET_NUM_DOCUMENTS, state.contract_types[i].docs_num);
//                 break;
//             }
//         }
//     }
// }

const closeContractModal = ({ commit }) => {
    commit(SET_SHOW_CONTRACT_MODAL, false);
    commit(SET_CONTRACT_MODAL_DISTRIBUTOR, false);
    commit(SET_IS_FACTURAE_PURCHASE_FOR_CLIENT, false);
    commit(SET_CONTRACT_MODAL_WORKING_HOURS_CLIENT, false);
    commit(SET_SHOW_ONLY_FACTURAE, false);
    commit(SET_IS_TAX_DATA_FILLED, false);
    commit(SET_CAN_SHOW_DOCUMENT_SERVICES_AND_BANKS, false);
    commit(SET_CAN_SHOW_MIXED, false);
    commit(SET_PERSONALIZED_SERVICES, false);
    commit(SET_STAFF_CONTRACT, { mode: '', contract: null });
};

const openContractModal = ({ commit }, {msg, distributor, facturae_client, working_hours_client, show_only_facturae, is_tax_data_filled, can_show_document_services_and_banks, can_show_mixed, personalized_services}) => {
    commit(SET_SHOW_CONTRACT_MODAL, true);
    commit(SET_CONTRACT_MODAL_MSG, msg);
    commit(SET_CONTRACT_MODAL_DISTRIBUTOR, distributor);
    commit(SET_IS_FACTURAE_PURCHASE_FOR_CLIENT, facturae_client);
    commit(SET_CONTRACT_MODAL_WORKING_HOURS_CLIENT, working_hours_client);
    commit(SET_SHOW_ONLY_FACTURAE, show_only_facturae);
    commit(SET_IS_TAX_DATA_FILLED, is_tax_data_filled);
    commit(SET_CAN_SHOW_DOCUMENT_SERVICES_AND_BANKS, can_show_document_services_and_banks);
    commit(SET_CAN_SHOW_MIXED, can_show_mixed);
    commit(SET_PERSONALIZED_SERVICES, personalized_services);
    commit(SET_STAFF_CONTRACT, { mode: '', contract: null });
}

// Abre el ContractPopup en modo staff. `contract` solo en mode='change'.
const openStaffContractModal = ({ commit }, { mode, contract }) => {
    commit(SET_CONTRACT_MODAL_MSG, '');
    commit(SET_CONTRACT_MODAL_DISTRIBUTOR, false);
    commit(SET_IS_FACTURAE_PURCHASE_FOR_CLIENT, false);
    commit(SET_CONTRACT_MODAL_WORKING_HOURS_CLIENT, false);
    commit(SET_SHOW_ONLY_FACTURAE, false);
    commit(SET_IS_TAX_DATA_FILLED, true);
    commit(SET_CAN_SHOW_DOCUMENT_SERVICES_AND_BANKS, false);
    commit(SET_CAN_SHOW_MIXED, false);
    commit(SET_PERSONALIZED_SERVICES, false);
    commit(SET_STAFF_CONTRACT, { mode, contract: contract || null });
    commit(SET_SHOW_CONTRACT_MODAL, true);
}

const closeExtraUserContractPopup = ({ commit }) => {
    commit(SET_IS_VISIBLE_EXTRA_USER_CONTRACT_POPUP, false);
    commit(SET_SELECTED_CONTRACT_FOR_EXTRA_USER_CONTRACT_POPUP, null);

}

const openExtraUserContractPopup = ({ commit }, {contract}) => {
    commit(SET_IS_VISIBLE_EXTRA_USER_CONTRACT_POPUP, true);
    commit(SET_SELECTED_CONTRACT_FOR_EXTRA_USER_CONTRACT_POPUP, contract);
}

const closePayChargePopup = ({ commit }) => {
    commit(SET_IS_VISIBLE_PAY_CHARGE_POPUP, false);
    commit(SET_SELECTED_CHARGE_FOR_PAY_CHARGE_POPUP, null);

}

const openPayChargePopup = ({ commit }, {charge}) => {
    commit(SET_IS_VISIBLE_PAY_CHARGE_POPUP, true);
    commit(SET_SELECTED_CHARGE_FOR_PAY_CHARGE_POPUP, charge);
}

const closeReinstallationPopup = ({ commit }) => {
    commit(SET_IS_VISIBLE_REINSTALLATION_POPUP, false);
    commit(SET_REINSTALLATION_POPUP_USER_ID, null);
}

const openReinstallationPopup = ({ commit }, {user_id}) => {
    commit(SET_REINSTALLATION_POPUP_USER_ID, user_id);
    commit(SET_IS_VISIBLE_REINSTALLATION_POPUP, true);
}

const notifyReinstallationCreated = ({ commit }) => {
    commit(NOTIFY_REINSTALLATION_CREATED);
}

const notifyContractsUpdated = ({ commit }) => {
    commit(NOTIFY_CONTRACTS_UPDATED);
}

const notifyPayChargeCompleted = ({ commit }) => {
    commit(NOTIFY_PAY_CHARGE_COMPLETED);
}

const updateScreenWidth = ({ commit }) => {
    if (window.innerWidth > 1200) {
        commit(SET_WIDTH, '37%');
        commit(SET_PERSISTENT, false);
    } else if (window.innerWidth > 950) {
        commit(SET_WIDTH, '50%');
        commit(SET_PERSISTENT, false);
    } else {
        commit(SET_WIDTH, '100%');
        commit(SET_PERSISTENT, true);
    }
}

const contractService = async ({ commit, dispatch, state },user_id) => {
//     let callback = (response) => {
//         let price = response['price'];
//         dispatch('payerContract', price);
//     };
//     dispatch('contracts/setServicePlan', state.form.contract_type, { root: true });
//     dispatch('contracts/setPromotionalCode', state.form.promotional_code, { root: true });
//     if (state.contract.is_trial) {
//         dispatch('contracts/upgradeTrialContract', {}, { root: true }).then(callback)
//     } else {
//         dispatch('contracts/createContract', {}, { root: true }).then(callback)
//     }
}

const payerContract = ({ commit }, price) => {
    let payment_params = new URLSearchParams();
    payment_params.append("amount",  price)
    client.get('get_paycomet_uri', { params: payment_params }).then((response) => {
        let paycometURI = response['data']['uri']
        window.open(paycometURI, "_self")
    })
} 

const setErrorPromotionalCode = ({ commit, state }, error_promotional_code) => {
    if (error_promotional_code) {
        commit(SET_ERROR_PROMOTIONAL_CODE, state.message_error.promotional_code);
    } else {
        commit(SET_ERROR_PROMOTIONAL_CODE, error_promotional_code);
    }
}

const showPrices = ({ commit }) => {
    const url = 'https://inmatic.ai/tarifas/'
    window.open(url, '_blank');
} 


const actions = {
    calculateContractDate,
    calculateEndDate,
    selectPlan,
    setServiceContract,
    setContractTypes,
    setErrorPromotionalCode,
    updateContractInfo,
    fillForm,
    openContractModal,
    openStaffContractModal,
    closeContractModal,
    openExtraUserContractPopup,
    closeExtraUserContractPopup,
    updateScreenWidth,
    openPayChargePopup,
    closePayChargePopup,
    openReinstallationPopup,
    closeReinstallationPopup,
    notifyReinstallationCreated,
    notifyContractsUpdated,
    notifyPayChargeCompleted,
    contractService,
    payerContract,
    showPrices
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}